import { Fancybox } from "@fancyapps/ui";

(function($) {
  $(function() {
    if($('.site-concept').length > 0) {
      $('.site-concept').each(function() {
        initSiteConcept($(this));
      });
    }
  });

  function initSiteConcept($wrapper) {
    var $markerA = $wrapper.find('#Marker-A');
    var $closeBtn = $wrapper.find('.site-concept__close');

    updateContentWrapperHeight($wrapper);

    $(window).resize(debounce(function() {
      updateContentWrapperHeight($wrapper);
    }, 300));

    $markerA.click(function() {
      $wrapper.addClass('site-concept--overlay-content');
    });

    console.log($('.site-concept__map .svg-map__fancybox'));

    $('.site-concept__map .svg-map__fancybox').click(function() {
      var url = $(this).data('url');
      if(url) {
        Fancybox.show([
          {
            src: url,
            type: "iframe",
            preload: false,
            width: 1000,
            height: 700,
          },
        ]);
      }
    })

    $closeBtn.click(function() {
      $wrapper.removeClass('site-concept--overlay-content');
    });
  }

  function updateContentWrapperHeight($wrapper) {
    if($(window).width() <= window.ScreenSM) {
      $wrapper.find('.site-concept__content').css('min-height', 0);
    } else {
      $wrapper.find('.site-concept__overlay-content').each(function() {
        var $content = $(this);
        var $contentWrapper = $content.parent();
        var contentHeight = $content.outerHeight(true, true);
        $contentWrapper.css('min-height', parseInt(contentHeight) + 'px');
      });
    }
  }
})(jQuery);
